function normalizeSortValue(value, type) {
  if (value == null || value === '') {
    if (type === 'number') return Number.NEGATIVE_INFINITY;
    if (type === 'date') return 0;
    return '';
  }
  if (type === 'number') {
    const n = Number(value);
    return Number.isFinite(n) ? n : Number.NEGATIVE_INFINITY;
  }
  if (type === 'date') {
    const t = new Date(value).getTime();
    return Number.isNaN(t) ? 0 : t;
  }
  return String(value).toLowerCase();
}

/**
 * @param {Array} items
 * @param {string} field
 * @param {'asc'|'desc'} direction
 * @param {Record<string, { type?: 'string'|'number'|'date', getValue?: (item: object) => unknown }>} fieldConfig
 */
export function sortList(items, field, direction, fieldConfig = {}) {
  const config = fieldConfig[field] || { type: 'string' };
  const getValue = config.getValue || ((item) => item?.[field]);
  const mult = direction === 'desc' ? -1 : 1;
  const type = config.type || 'string';

  return [...(items || [])].sort((a, b) => {
    const va = normalizeSortValue(getValue(a), type);
    const vb = normalizeSortValue(getValue(b), type);
    if (va < vb) return -1 * mult;
    if (va > vb) return 1 * mult;
    return 0;
  });
}

export const JOB_SORT_FIELD_CONFIG = {
  created_at: { label: 'Created', type: 'date' },
  customer_name: { label: 'Customer', type: 'string' },
  job_status: { label: 'Status', type: 'string' },
  payment_status: { label: 'Payment status', type: 'string' },
  driver_name: { label: 'Driver', type: 'string' },
  scheduled_date: { label: 'Scheduled date', type: 'date' },
  completed_at: { label: 'Completed date', type: 'date' },
};

export const INVOICE_SORT_FIELD_CONFIG = {
  created_at: { label: 'Created', type: 'date' },
  invoice_number: { label: 'Invoice number', type: 'string' },
  customer_name: { label: 'Customer', type: 'string' },
  amount: { label: 'Amount', type: 'number' },
  total_amount: { label: 'Total', type: 'number' },
  status: { label: 'Status', type: 'string' },
  due_date: { label: 'Due date', type: 'date' },
};

export function sortFieldOptions(fieldConfig) {
  return Object.entries(fieldConfig).map(([value, { label }]) => ({ value, label }));
}
